export default "__VITE_ASSET__D7dyNE5n__"